export const NutritionalParameter = (json: INutritionalParameter): INutritionalParameterModel => {
	const { name, short_name, is_required, created_at, updated_at, ...rest } = json

	return {
		...rest,
		name: LangContentToModel(name),
		shortName: LangContentToModel(short_name),
		isRequired: is_required,
		updatedAt: updated_at ? new Date(updated_at) : null,
		createdAt: created_at ? new Date(created_at) : null,
	}
}

export const NutritionalParameterWithValue = (
	json: INutritionalParameterWithValue,
): INutritionalParameterWithValueModel => {
	const { name, short_name, is_required, created_at, updated_at, ...rest } = json

	return {
		...rest,
		name: LangContentToModel(name),
		shortName: LangContentToModel(short_name),
		isRequired: is_required,
		updatedAt: updated_at ? new Date(updated_at) : null,
		createdAt: created_at ? new Date(created_at) : null,
	}
}
